import { render } from "./SupervisorPage.vue?vue&type=template&id=1fbf9bb6"
import script from "./SupervisorPage.vue?vue&type=script&lang=js"
export * from "./SupervisorPage.vue?vue&type=script&lang=js"

import "./SupervisorPage.vue?vue&type=style&index=0&id=1fbf9bb6&lang=scss"

import exportComponent from "/home/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QCard,QCardSection,QSeparator});
